import { getRequest } from "../../api/ui/common/export.js";
import { buildTableQuery } from "../../api/query-params";
/* eslint-disable array-callback-return */
/* eslint-disable no-loop-func */
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Button, CircularProgress } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { alpha, styled } from "@mui/material/styles";

import React from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";



const Exports = ({
  filter,
  header,
  data,
  selectedData,
  variant = "contained",
  name = "خروجی اکسل",
  title,
  api,
  param = false,
  extraParams = false,
  sumbitSearch = false,
  requestExport = getRequest
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [loading, setloading] = React.useState(false);
  const [loading2, setloading2] = React.useState(false);
  const [loading3, setloading3] = React.useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const { token } = useSelector((state) => state.user);
  const allExels = (datas) => {
    var name = "";
    filter?.map((item) => {
      if (item.isDate) {
        name += " - " + new Date(item.date).toLocaleDateString("fa-IR");
      }
    });
    var temp = [...datas?.body];
    temp.unshift(datas.header);
    var wb = XLSX.utils.book_new(),
      ws = XLSX.utils.aoa_to_sheet(temp);

    XLSX.utils.book_append_sheet(wb, ws, title);
    XLSX.writeFile(
      wb,
      `${
        title +
        " " +
        (name ? name.slice(3) : new Date().toLocaleDateString("fa-IR"))
      }.xlsx`
    );
    handleClose();
  };
  const allData = (chooseSelected, chooseFilter) => {
    var params = "";
    const query = buildTableQuery({ scope: param,
      filter: chooseFilter ? filter : [], search: chooseFilter ? sumbitSearch : false });
    const temp = `&${query}`;
    if (chooseSelected) {
      setloading3(true);
      selectedData.map((items) => {
        params += `,${items.id}`;
      });
    }
    if (chooseFilter) {
      setloading2(true);
    }
    if (!chooseSelected && !chooseFilter) {
      setloading(true);
    }

    requestExport(api, extraParams, params, temp, token)
      .then((res) => {
        const { data } = res;
        allExels(data?.data);
        setloading(false);
        setloading2(false);
        setloading3(false);
        params = "";
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || err.message || "دریافت خروجی انجام نشد.");
        setloading(false);
        setloading2(false);
        setloading3(false);
      });
  };
  return (
    <div>
      <Button
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant={variant}
        color="warning"
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        {name}
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            if (selectedData && selectedData.length > 0) {
              allData(true, false);
            } else {
              toast.error("موردی انتخاب نشده است");
            }
          }}
          disableRipple
        >
          {loading3 ? (
            <CircularProgress
              sx={{
                width: "12px !important",
                height: "12px !important",
                mx: 1,
              }}
            />
          ) : (
            <FileDownloadIcon />
          )}
          خروجی موارد انتخاب شده
        </MenuItem>
        <MenuItem onClick={() => allData(false, true)} disableRipple>
          {loading2 ? (
            <CircularProgress
              sx={{
                width: "12px !important",
                height: "12px !important",
                mx: 1,
              }}
            />
          ) : (
            <FileDownloadIcon />
          )}
          خروجی براساس فیلتر
        </MenuItem>

        <MenuItem onClick={() => allData(false, false)} disableRipple>
          {loading ? (
            <CircularProgress
              sx={{
                width: "12px !important",
                height: "12px !important",
                mx: 1,
              }}
            />
          ) : (
            <FileDownloadIcon />
          )}
          خروجی کلی
        </MenuItem>
      </StyledMenu>
    </div>
  );
};

export default Exports;
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));
/*   var range = XLSX.utils.decode_range(ws["!ref"]);
    for (var C = range.s.c; C <= range.e.c; ++C) {
      var address = XLSX.utils.encode_col(C) + "1";
      if (!ws[address]) continue;
      var finded = header?.find((item) => item.name === ws[address].v);
      if (finded) {
        ws[address].v = finded.title;
      }
    } */
